<template>
    <div class="master-badge " :class="{
      [`master-badge--${styleType}`]:styleType,
      'master-badge--disabled': worker.leaved_at
    }">
        <template v-if="worker.leaved_at == null">

            <div role="button" class="position-relative worker__wrapper"
                 @click.stop="
                        showContextModal({
                            type: type,
                            id: worker.id,
                            name: worker.name,
                            away: worker.away
                        })
                    "
            >
              <h2 class="worker__name">
                {{ worker.name }}
              </h2>
                <div
                    v-if="!worker.away"
                    class="worker__img d-flex align-items-center justify-content-center overflow-hidden"

                >
                    <v-list-item-avatar :size="styleType ? 40 : 80" color="grey" style="margin-right: 0">
                        <v-icon dark :size="styleType ? 40 : 80">
                            mdi-account-circle
                        </v-icon>
                    </v-list-item-avatar>
                </div>
                <div
                    v-else
                    class="worker__img d-flex align-items-center justify-content-center overflow-hidden"
                >
                    <img
                        :src="'/images/shift/icon/away.png'"
                        alt=""
                        class="img-fluid"
                    />
                </div>
                <div class="worker__position mt-1">
                    <span class="small text-truncate">{{
                        worker.displayRole
                    }}</span>
                </div>
            </div>
        </template>
        <template v-else>

            <div role="button" class="position-relative worker__wrapper"
                 @click.stop="
                        showContextModal({
                            type: type,
                            id: worker.id,
                            name: worker.name,
                            away: worker.away
                        })
                    "
            >
              <h2 class="worker__name">
                {{ worker.name }}
              </h2>
                <div
                    class="worker__img d-flex align-items-center justify-content-center overflow-hidden"

                >
                    <img
                        :src="
                            'https://eu.ui-avatars.com/api/?name=' + worker.name
                        "
                        alt=""
                        class="img-fluid"
                    />
                </div>
                <div class="worker__position mt-1">
                    <span class="small text-truncate">{{
                        worker.displayRole
                    }}</span>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
    props: ["worker", "type", "styleType"],
    computed: {
        ...mapGetters('shift', ["shiftInfo"])
    },
    methods: {
        showContextModal(payload) {
            this.$store.commit("shift/updateContextEmployee", payload);
            this.$store.dispatch('shift/setContextModal', true)
        }
    }
};
</script>

<style lang="scss">
.master-badge--disabled {
  pointer-events: none;
  .worker__name,
  .worker__position {
    color: rgba(black, 0.5)
  }
  .worker__img {
    opacity: 0.8;
    img {
      display: none;
    }
  }
}
.master-badge--row {
  width: 100%;
  .worker__wrapper {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    width: 100%;
  }
  .worker__img {
    grid-area: 1 / 1 / 3 / 2;
  }
  .worker__name {
    text-align: start;
    grid-area: 1 / 2 / 2 / 4;
    margin-bottom: 0 !important;
    display: flex;
    align-self: center;
    justify-content: flex-start;
  }
  .worker__position {
    display: flex;
    align-self: flex-start;
    justify-content: flex-start;
    grid-area: 2 / 2 / 3 / 4;
    margin-top: 0 !important;
  }
  .worker__img {
    width: 40px;
    height: 40px;
  }
}
.worker__name {
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: #000000;
}
.active .worker__name {
    font-weight: 600 !important;
}
.worker__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.worker__img {
    position: relative;
    width: 60px;
    height: 60px;
    background: #d8d8d8;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.worker__img:hover {
    -moz-box-shadow: 0 0 5px 5px #c8fa92;
    -webkit-box-shadow: 0 0 5px 5px #c8fa92;
    box-shadow: 0 0 5px 5px #b5e97c;
}
</style>
